<template>
  <LocaleLink :href="href">
    <slot :active="isActive(entry)" />
  </LocaleLink>
</template>

<script lang="ts" setup>
import type { INote, ISchema } from "~/models/IUserEntry";

const props = defineProps<{
  entry: ISchema | INote;
}>();

const { isActive } = useActiveEntryRouteParams();
const { linkToEntry } = useSetActiveEntry();

const href = computed(() => linkToEntry(props.entry));
</script>
